import type { Client } from '@zg-rentals/http-client';
import { createClient } from '@zg-rentals/http-client';
import { makeAppInstance } from '@zg-rentals/util';

export const { get: getClient, set: setClient } = makeAppInstance<Client | undefined>(
  () => undefined,
  '@zg-rentals/ts-dragnet-client:client',
);
export { createClient };
